document.addEventListener("DOMContentLoaded", () => {
  const filterToggles = Array.from(
    document.querySelectorAll(".js-toggle-filter")
  );

  filterToggles.forEach((filter) => {
    filter.addEventListener("click", () => {
      filter.parentElement.classList.toggle("collapsed");
    });
  });

  // init audience filter
  initFilters(".js-audience-filter", "audience");

  // init content type filter
  initFilters(".js-type-filter", "type");

  // init industry/topic filter
  initFilters(".js-industry-filter", "industry");

  // init the mobile filter toggle
  initMobileFilterToggle();

  // init load more button
  initLoadMore();

  // init the issue reporting modal and form
  initIssueReportModal();

  // init clear filters button
  const clearFilterButton = document.getElementById("js-clear-filters");
  if (clearFilterButton) {
    clearFilterButton.addEventListener("click", () => {
      // clear filters
      updateUrl();
    });
  }
});

/**
 * Inits the different filter types
 *
 * @param {string} className - Target class name for setting the event listener
 * @param {string} param     - Parameter that is inserted into the URL for filtering
 *
 * @returns void
 */
function initFilters(className, param) {
  const url = new URL(window.location);
  const filterParams = url.searchParams.get(param);

  const filters = Array.from(document.querySelectorAll(className));

  if (!filters.length) return;

  filters.forEach((filter) => {
    if (filterParams) {
      const selectedFilters = filterParams.split(",");
      filter.checked = selectedFilters.includes(filter.value);
    }

    filter.addEventListener("change", () => {
      const newFilters = Array.from(filters)
        .filter((checkbox) => checkbox.checked)
        .map((checkbox) => checkbox.value);

      debouncedUpdateUrl(newFilters, param);
    });
  });
}

/**
 * Mobile filter toggle
 *
 * @returns void
 */
function initMobileFilterToggle() {
  const filterToggle = document.getElementById("js-toggle-filters");
  const filterWrapper = document.getElementById("js-filters");

  if (!filterToggle || !filterWrapper) return;

  filterToggle.addEventListener("click", () => {
    if (filterToggle.classList.contains("expanded")) {
      filterToggle.classList.remove("expanded");
      filterWrapper.style.maxHeight = "0px";
    } else {
      filterToggle.classList.add("expanded");
      filterWrapper.style.maxHeight = `${filterWrapper.scrollHeight}px`;
    }
  });
}

/**
 * Set the hidden form field values
 *
 * @param {string} title - Resource title
 * @param {string} link  - resource link
 * @returns void
 */
function setHiddenFormFields(title, link) {
  const TitleField = document.getElementById(
    "IssueReportForm_IssueReportForm_ResourceTitle"
  );
  const LinkField = document.getElementById(
    "IssueReportForm_IssueReportForm_ResourceLink"
  );

  if (!TitleField && !LinkField) return;

  TitleField.value = title;
  LinkField.value = link;
}

/**
 * Set the hidden form field values
 *
 * @param {string|null} filters - Selected filter ID's that are inserted into the URL
 * @param {string|null} param   - URL parameter that is used for filtering resources (e.g. ?industry=9,12&audience=4)
 * @returns void
 */
function updateUrl(filters = null, param = null) {
  const url = new URL(window.location);

  if (!param) {
    url.search = "";
  } else {
    url.searchParams.set(param, filters.join(","));
  }

  window.history.pushState({}, "", url);

  window.location.reload();
}

/**
 * Delays the updaye of the url so that users
 * have time to select multiple filters
 * before the page reloads
 */
function debounce(func, delay) {
  let timeout;
  return function (...args) {
    const context = this;
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(context, args), delay);
  };
}

// Debounced version of updateUrl
const debouncedUpdateUrl = debounce(updateUrl, 1000);

/**
 * Init the Issue Report Form
 *
 * Uses AJAX to submit data to
 * ResourcesPageController::submitIssueReportForm()
 *
 * @param {HTMLElement} form - Issue report form element
 * @returns void
 */
function initIssueReportForm(form) {
  const sucessMessage = document.querySelector(".js-issue-report-form-success");

  form.addEventListener("submit", (e) => {
    e.preventDefault();

    form.classList.add("submitting");

    const page = document.location.href.split("?")[0];

    try {
      const formData = new FormData(form);

      fetch(`${page}/submitIssueReportForm`, {
        headers: {
          "x-requested-with": "XMLHttpRequest",
        },
        method: "POST",
        body: formData,
      })
        .then((response) => response.json())
        .then((response) => {
          if (response["success"]) {
            if (sucessMessage) {
              sucessMessage.classList.add("show");
            }
            form.style.display = "none";
          } else {
            form.classList.remove("submitting");
            showError(emailField, "An error occurred. Please try again.");
          }
        });
    } catch (error) {
      form.classList.remove("submitting");
      showError(emailField, "An error occurred. Please try again.");
    }
  });
}

/**
 * Reset the issue report form so that it can be submitted again
 *
 * @param {HTMLElement} form - Issue report form element
 * @returns void
 */
function resetIssueReportForm(form) {
  if (!form.classList.contains("submitting")) return;

  const fields = Array.from(form.querySelectorAll("input,textarea"));

  fields.forEach((field) => {
    field.value = "";
  });

  const sucessMessage = document.querySelector(".js-issue-report-form-success");

  sucessMessage.classList.remove("show");

  form.classList.remove("submitting");
  form.style.display = "block";
}

/**
 * Init the load more button
 *
 * Uses fetch method to grab additional resources from
 * the backend
 *
 * @returns void
 */
function initLoadMore() {
  const loadMore = document.getElementById("js-show-more");
  const resources = document.getElementById("js-resources");

  if (!loadMore || !resources) return;

  // Get initial page length
  const pageLength = loadMore.getAttribute("data-length");
  const pageLengthInt = parseInt(pageLength);

  // Initialize the start parameter
  let start = pageLengthInt;

  loadMore.addEventListener("click", () => {
    loadMore.classList.add("loading");

    const url = new URL(window.location.href);
    const page = document.location.href.split("?")[0];

    const audience = url.searchParams.get("audience") || "";
    const type = url.searchParams.get("type") || "";
    const industry = url.searchParams.get("industry") || "";

    let endpoint = `${page}/getMoreResources?start=${start}`;

    if (audience) {
      endpoint += `&audience=${audience}`;
    }
    if (type) {
      endpoint += `&type=${type}`;
    }
    if (industry) {
      endpoint += `&industry=${industry}`;
    }

    // if the current url has a ?stage=1 parameter, add it to the endpoint
    const stage = url.searchParams.get("stage");
    if (stage) {
      endpoint += `&stage=${stage}`;
    }

    fetch(endpoint)
      .then((response) => response.json())
      .then((data) => {
        const resourceItems = data.items;

        if (resourceItems && resourceItems.length > 0) {
          resourceItems.forEach((resource) => {
            const resourceMarkup = createResourceMarkup(resource);
            resources.insertAdjacentHTML("beforeend", resourceMarkup);
          });

          if (data.moreThanOnePage && data.items.length === pageLengthInt) {
            // Increment the start parameter for the next request
            start += pageLengthInt;
          } else {
            loadMore.style.display = "none";
          }
        } else {
          loadMore.style.display = "none";
        }

        loadMore.classList.remove("loading");
      })
      .catch((error) => {
        loadMore.classList.remove("loading");
        console.error("Error loading more resources:", error);
      });
  });
}

/**
 * Creates the Engagement Resource markup that is then
 * inserted into the HTML
 *
 * @param {object} resource - Engagement Resource data
 * @returns string
 */
function createResourceMarkup(resource) {
  return `
    <li class="resource">
      <a href="${resource.LinkURL}" target="_blank">
        <div class="resource__background" style="background-image:url(${
          resource.ImageURL
        })">
          ${
            resource.ContentType
              ? `<div class="resource__tag"><span>${resource.ContentType}</span></div>`
              : ""
          }
          <svg viewBox="0 0 21 21" xmlns="http://www.w3.org/2000/svg"><g fill="#000000" fill-rule="nonzero"><path d="M2.019 20.772h15.966c.628 0 1.14-.513 1.14-1.14v-9.124h-2.28v7.983H3.159V4.805h7.984v-2.28H2.019c-.628 0-1.14.512-1.14 1.14V19.63c0 .628.512 1.14 1.14 1.14z"/><path d="M9.688 10.393l1.597 1.597 7.384-7.356v2.48h2.281V.756h-6.386v2.281h2.48z"/></g></svg>
        </div>
      </a>
      <div class="resource__inner">
        <a href="${resource.LinkURL}">
          <p class="resource__title">${resource.Title}</p>
        </a>
        <p class="resource__description">${resource.Content}</p>
      </div>
      <div class="resource__issue">
        <div class="js-report-issue resource__issue--inner" data-title="${
          resource.Title
        }" data-link="${resource.AbsoluteURL}">
          <div class="resource__issue--tooltip">
            <span>Issues with the link?</span>
          </div>
          <img src="/_resources/themes/worksafe/images/exclamation-circle.svg" class="resource__issue--icon">
        </div>
      </div>
    </li>
  `;
}

/**
 * Inits the Issue Report modal and required functionality
 *
 * @returns void
 */
function initIssueReportModal() {
  const issueReportButtons = Array.from(
    document.querySelectorAll(".js-report-issue")
  );
  const issueReportModal = document.getElementById("report-modal");
  const closeReportModal = document.querySelector(".js-close-report-modal");

  if (issueReportButtons.length == 0 || !issueReportModal) return;

  issueReportButtons.forEach((button) => {
    button.addEventListener("click", () => {
      issueReportModal.classList.add("show");

      const title = button.getAttribute("data-title");
      const link = button.getAttribute("data-link");

      setHiddenFormFields(title, link);
    });
  });

  const issueReportForm = document.getElementById(
    "IssueReportForm_IssueReportForm"
  );

  if (issueReportForm) {
    initIssueReportForm(issueReportForm);
  }

  closeReportModal.addEventListener("click", () => {
    issueReportModal.classList.remove("show");
    resetIssueReportForm(issueReportForm);
  });
}
